import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { FileResponse } from '@app/models/shared.models';
import { ImgGalleryItemComponent } from './img-gallery-item/img-gallery-item.component';

import GLightbox from 'glightbox';

@Component({
  selector: 'app-img-gallery',
  imports: [CommonModule, ImgGalleryItemComponent],
  templateUrl: './img-gallery.component.html',
  styleUrl: './img-gallery.component.scss',
})
export class ImgGalleryComponent implements AfterViewInit, OnInit {
  private lightbox: any;
  private isOpen: boolean = false;
  private reinitTimer: any;
  images = input.required<FileResponse[]>();
  perRow = input<number>(5);
  maxToDisplayAmount = input<number | null>(null);
  private displayLimit = signal<number | null>(null);
  moreClicked = output<boolean>();

  processedImageArray = computed(() => {
    if (this.displayLimit() === null) {
      return this.images();
    }
    return this.images().slice(0, this.displayLimit()!);
  });
  remainingImgCount = computed(() => {
    if (this.displayLimit() === null) {
      return 0;
    }
    const remainingCount = this.images().length - this.displayLimit()!;
    return remainingCount < 1 ? 0 : remainingCount;
  });

  ngOnInit(): void {
    this.displayLimit.set(this.maxToDisplayAmount());
  }

  ngAfterViewInit(): void {
    this.initLightbox();
  }

  private blockScroll = (e: Event) => {
    if (!this.isOpen) return;
    e.preventDefault();
  };

  private initLightbox() {
    this.lightbox = GLightbox({
      selector: '.galleryimgs',
      loop: true,
    });

    this.lightbox.on('open', () => {
      this.isOpen = true;

      this.showAll();

      window.addEventListener('wheel', this.blockScroll, { passive: false });
      window.addEventListener('touchmove', this.blockScroll, {
        passive: false,
      });
    });

    this.lightbox.on('close', () => {
      this.isOpen = false;

      window.removeEventListener('wheel', this.blockScroll);
      window.removeEventListener('touchmove', this.blockScroll);
    });
  }

  reInitLightbox() {
    if (this.isOpen) return;

    clearTimeout(this.reinitTimer);
    this.reinitTimer = setTimeout(() => {
      this.lightbox?.destroy();
      this.initLightbox();
    }, 100);
  }

  showAll() {
    this.displayLimit.set(null);
  }
}
